export default __webpack_public_path__ + "static/media/LOGO-CONMED-COLLAPSED.1217c2fa.png";